export default __webpack_public_path__ + "static/media/bem-vindo-imagem.696f282c.svg";